
import FiltroInterface from "@/interfaces/Filtro";
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import ProdutosService from "../../../services/ProdutosService";

const Notifications = namespace("Notifications");

@Component({
  name: "FiltroCategoriaProdutos",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
})
export default class FiltroCategoriaProdutos extends Vue {
  @Notifications.Action
  showErrorMessage!: (message: string) => Promise<any>;

  private filtros = [] as FiltroInterface[];
  private searchText = "";
  private textSearchTimer;
  private panelStates = [] as Array<any>;
  private internalSelectedFilters = {
    Grupo: [] as Array<any>,
    Subgrupo: [] as Array<any>,
    Familia: [] as Array<any>,
    Marca: [] as Array<any>,
  };
  private internalCategoriasList = [] as Array<any>;

  get mobileBreakpoint() {
    return this.$vuetify.breakpoint.mdAndDown;
  }

  get categoriasList() {
    const textFilteredCategorias = (list: Array<any>) => {
      if (this.searchText) {
        return list.map((categoria, index) => {
          const result = {
            ...categoria,
            data: categoria.data.filter((dt) =>
              dt.descricao
                ?.toLowerCase()
                .includes(this.searchText.toLowerCase())
            ),
          };
          if (result.data.length > 0) {
            this.panelStates.push(index);
          }
          return result;
        });
      }
      return list || [];
    };

    const subgrupoFilteredCategorias = (list: Array<any>) => {
      return list.map((categoria) => {
        if (categoria.name === "Subgrupo") {
          const gruposIds = this.internalSelectedFilters?.["Grupo"]?.map(
            (grp) => {
              const grpObj = JSON.parse(grp);
              return grpObj.id;
            }
          ) as Array<number>;

          if (gruposIds?.length > 0) {
            return {
              ...categoria,
              data: categoria.data.filter((subCat) =>
                gruposIds.includes(subCat.grupoId)
              ),
            };
          } else {
            this.panelStates = this.panelStates.filter((el) => el !== 1); //indice painel subgrupos

            return {
              ...categoria,
              data: [],
            };
          }
        }
        return categoria;
      });
    };

    const textFilteredItems = textFilteredCategorias(
      this.internalCategoriasList
    );
    const subgrupoFilteredItems = subgrupoFilteredCategorias(textFilteredItems);

    return subgrupoFilteredItems;
  }

  shouldDisableCategoriaPanel(categoria: any) {
    if (categoria.name === "Subgrupo") {
      if (this.internalSelectedFilters?.["Grupo"]?.length <= 0) {
        return true;
      }
    }

    return categoria.data.length <= 0;
  }

  onSearchTextChanged(value: string) {
    clearTimeout(this.textSearchTimer);
    this.textSearchTimer = setTimeout(() => {
      this.panelStates = [] as Array<any>;
      this.searchText = value;
    }, 600);
  }

  onCategoriaCheckChanged(event: any, categoria: any) {
    // this.atualizarURLComCategorias();

    const filtros = this.getSelectedFilters;
    
    this.$router.push({
      query: {
        ...this.$route.query,
        grupo: filtros
          .filter((el: any) => el.categoria === "Grupo")
          .map((el: any) => el.descricao)
          .join(","),
        subgrupo: filtros
          .filter((el: any) => el.categoria === "Subgrupo")
          .map((el: any) => el.descricao)
          .join(","),
        familia: filtros
          .filter((el: any) => el.categoria === "Familia")
          .map((el: any) => el.descricao)
          .join(","),
        marca: filtros
          .filter((el: any) => el.categoria === "Marca")
          .map((el: any) => el.descricao)
          .join(","),
      },
    });

    if (categoria.name === "Grupo" && event.length == 0) {
      this.internalSelectedFilters["Subgrupo"] = [];
    }
    
    this.$emit("input", this.getSelectedFilters);
  }

  /**
   * Retorno de objeto {categoria: descricao da categoria, id: ID do item da categoria, descricao: descricao do item da categoria}
   */
  get getSelectedFilters() {
    const buscarObjetosCategoriaFiltrados = (
      categoriaItems: Array<any>,
      nomeCategoria: string
    ) => {
      return categoriaItems?.filter((item) => {
        const found = this.internalSelectedFilters?.[nomeCategoria].find(
          (filter) => {
            const asObject = JSON.parse(filter);
            return (
              asObject.id === item.id &&
              (nomeCategoria === "Subgrupo"
                ? asObject.grupoId == item.descricao
                : true)
            );
          }
        );

        return !!found;
      });
    };

    return Object.keys(this.internalSelectedFilters).reduce(
      (resultCategoria: any, nomeCategoria: string) => {
        const categoriaItems = this.categoriasList?.find(
          (el) => el.name === nomeCategoria
        );

        const selectedCategoriaFilters = buscarObjetosCategoriaFiltrados(
          categoriaItems?.data,
          nomeCategoria
        );

        const result =
          selectedCategoriaFilters?.map((el) => {
            return {
              categoria: nomeCategoria,
              ...el,
            };
          }) || [];

        return [...resultCategoria, ...result];
      },
      []
    );
  }

  // Função para atualizar a URL com as categorias selecionadas
  atualizarURLComCategorias() {
    const categorias = this.getSelectedFilters;

    const grupos = categorias
      .filter((el) => el.categoria === "Grupo")
      ?.map((el) => el.descricao);
    const subgrupos = categorias
      .filter((el) => el.categoria === "Subgrupo")
      ?.map((el) => el.descricao);
    const familias = categorias
      .filter((el) => el.categoria === "Familia")
      ?.map((el) => el.descricao);
    const marcas = categorias
      .filter((el) => el.categoria === "Marca")
      ?.map((el) => el.descricao);

    const url = new URL(window.location.href);

    if (grupos?.length) url.searchParams.set("grupo", grupos.join(","));
    if (subgrupos?.length)
      url.searchParams.set("subgrupo", subgrupos.join(","));
    if (familias?.length) url.searchParams.set("familia", familias.join(","));
    if (marcas?.length) url.searchParams.set("marca", marcas.join(","));

    if (!grupos?.length) url.searchParams.delete("grupo");
    if (!subgrupos?.length) url.searchParams.delete("subgrupo");
    if (!familias?.length) url.searchParams.delete("familia");
    if (!marcas?.length) url.searchParams.delete("marca");

    url.searchParams.delete("page");
    url.searchParams.delete("number");

    window.history.pushState({}, "", url.toString());
  }

  // Função para ler as categorias da URL quando o componente for montado
  lerCategoriasDaURL() {
    const url = new URL(window.location.href);
    const grupos = url.searchParams.get("grupo")?.split(",");
    const subcategorias = url.searchParams.get("subgrupo")?.split(",");
    const familias = url.searchParams.get("familia")?.split(",");
    const marcas = url.searchParams.get("marca")?.split(",");

    const categoriasFiltradas = this.internalCategoriasList.filter(
      (el) =>
        el.name === "Grupo" ||
        el.name === "Subgrupo" ||
        el.name === "Familia" ||
        el.name === "Marca"
    );

    for (const categoria of categoriasFiltradas) {
      if (categoria.name === "Grupo") {
        for (const item of categoria.data) {
          if (grupos?.includes(item.descricao)) {
            this.internalSelectedFilters?.[categoria.name].push(
              JSON.stringify({ id: item.id, grupoId: item.descricao })
            );
          }
        }
      } else if (categoria.name === "Subgrupo") {
        for (const item of categoria.data) {
          if (subcategorias?.includes(item.descricao)) {
            this.internalSelectedFilters?.[categoria.name].push(
              JSON.stringify({ id: item.id, grupoId: item.descricao })
            );
          }
        }
      } else if (categoria.name === "Familia") {
        for (const item of categoria.data) {
          if (familias?.includes(item.descricao)) {
            this.internalSelectedFilters?.[categoria.name].push(
              JSON.stringify({ id: item.id, grupoId: item.descricao })
            );
          }
        }
      } else if (categoria.name === "Marca") {
        for (const item of categoria.data) {
          if (marcas?.includes(item.descricao)) {
            this.internalSelectedFilters?.[categoria.name].push(
              JSON.stringify({ id: item.id, grupoId: item.descricao })
            );
          }
        }
      }
    }
  }

  onSearchClick() {
    this.$emit("closeDrawer");
  }

  mounted() {
    this.buscarCategorias();
  }

  getGrupoBySlug(grupo: string, subgrupo: string, familia: string, marca: string) {
    return this.getSelectedFilters;
  }

  onLimparFiltrosClick() {
    this.internalSelectedFilters = {
      Grupo: [] as Array<any>,
      Subgrupo: [] as Array<any>,
      Familia: [] as Array<any>,
      Marca: [] as Array<any>,
    };

    // this.atualizarURLComCategorias();
    this.$router.push({
      query: {
        ...this.$route.query,
        grupo: null,
        subgrupo: null,
        familia: null,
        marca: null,
      },
    });
    
    this.$emit("input", this.getSelectedFilters);
  }

  onRemoveFilter(item: any) {
    this.internalSelectedFilters[item.categoria] = this.internalSelectedFilters[
      item.categoria
    ].filter((el: any) => {
      const asObject = JSON.parse(el);
      return asObject.id !== item.id;
    });

    // this.atualizarURLComCategorias();
    
    const filtros = this.getSelectedFilters;

    this.$router.push({
      query: {
        ...this.$route.query,
        grupo: filtros
          .filter((el: any) => el.categoria === "Grupo")
          .map((el: any) => el.descricao)
          .join(","),
        subgrupo: filtros
          .filter((el: any) => el.categoria === "Subgrupo")
          .map((el: any) => el.descricao)
          .join(","),
        familia: filtros
          .filter((el: any) => el.categoria === "Familia")
          .map((el: any) => el.descricao)
          .join(","),
        marca: filtros
          .filter((el: any) => el.categoria === "Marca")
          .map((el: any) => el.descricao)
          .join(","),
      },
    });
    
    this.$emit("input", this.getSelectedFilters);
  }

  buscarCategorias() {
    ProdutosService.getCategorias()
      .then((resp) => {
        const filtersObject = resp.data.reduce((result, current) => {
          return {
            ...result,
            [current.name]: [],
          };
        }, {});

        this.filtros.forEach((el: any) => {
          filtersObject[el.categoria].push(
            JSON.stringify({ id: el.id, grupoId: el.grupoId || null })
          );
        });

        this.internalCategoriasList = resp.data;

        this.lerCategoriasDaURL();

        const filtros = this.getSelectedFilters;

        this.$emit("input", this.getSelectedFilters);
      })
      .catch((error) => {
        this.showErrorMessage(
          `Falha ao consultar categorias de pesquisa: ${
            error.response?.data || error
          }`
        );
      });
  }
}
